import * as yup from "yup";

export const CONTRACT_SELLER_EDIT_FORM_SCHEMA = yup.object().shape({
  lessorSalesPersonName: yup.string().required("Ime kontakt osobe je obavezan podatak"),
  lessorPhoneNumber: yup.string().required("Telefon najmodavca je obavezan podatak"),
});
